<script>
export default {
    name: 'BaseJsonFormItemDate',
};
</script>

<script setup>
import { computed } from 'vue';
import toISOString from '@/assets/util/to-iso-string';
import toISOTime from '@/assets/util/to-iso-time';

const props = defineProps({
    value:     {
        type: String,
    },
    title:     {
        type: String,
    },
    type:      {
        type: String,
    },
    format:    {
        type: String,
    },
    disabled:  {
        type: Boolean,
    },
    clearable: {
        type: Boolean,
    },
});

const isDate = computed(() => props.type === 'date' || props.format === 'date');
const isTime = computed(() => props.type === 'time' || props.format === 'time');
const formattedValue = computed(() => (!isTime.value ? props.value : `2000-01-01T${props.value}`));

const emit = defineEmits({
    input: null,
});

const model = computed({
    get() {
        const parsed = Date.parse(formattedValue.value);

        if (Number.isNaN(parsed)) return undefined;

        return new Date(formattedValue.value);
    },
    set(value) {
        if (!value) return;

        emit('input', isTime.value ? toISOTime(value) : toISOString(value));
    },
});
</script>

<template>
    <base-date-picker
        v-if="isDate"
        v-model="model"
        size="large"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="title"
    />
    <base-time-picker
        v-else-if="isTime"
        v-model="model"
        size="large"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="title"
        with-seconds
    />
    <base-date-picker
        v-else
        v-model="model"
        size="large"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="title"
        with-time
    />
</template>
